function csv(value: string | undefined, fallback: string): string[] {
  return (value || fallback)
    .split(",")
    .map((role: string) => role.trim())
    .filter((role: string) => role.length > 0);
}

export const env = {
  apiBaseUrl: import.meta.env.VITE_ADMIN_API_BASE_URL || "",
  keycloakUrl: import.meta.env.VITE_KEYCLOAK_URL || "https://dev-auth.doctor-server.com",
  keycloakRealm: import.meta.env.VITE_KEYCLOAK_REALM || "dserver.by",
  keycloakClientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || "telemetry-admin-ui",
  requiredRoles: csv(import.meta.env.VITE_REQUIRED_ROLES, "telemetry-admin,telemetry-operator"),
  e2eAuthToken: import.meta.env.VITE_E2E_AUTH_TOKEN || "",
  e2eAuthUser: import.meta.env.VITE_E2E_AUTH_USER || "telemetry-admin-ui-e2e"
};
